import React, { Component } from 'react';

class WindowSize extends Component {
	render() {
		const {windowDimensionW, windowDimensionH} = this.props;
		return (
			<tr>
				<th>Window Size</th>
				<td>{windowDimensionW}cm x {windowDimensionH}cm</td>
				<td></td>
			</tr>
		);
	}
}
export default WindowSize;